import React from 'react';
import moment from 'moment';

export default class RoadmapEntity {

  static ID = 'roadmap';

  static attachmentShape = {
    id: React.PropTypes.string.isRequired,
    fileName: React.PropTypes.string.isRequired,
    loading: React.PropTypes.bool,
    updating: React.PropTypes.bool,
  };

  static auditShape = {
    creationDateTime: React.PropTypes.string, // yyyy-MM-dd'T'HH:mm:ss
    updateDateTime: React.PropTypes.string, // yyyy-MM-dd'T'HH:mm:ss
  };

  static shape = {
    id: React.PropTypes.string.isRequired,
    fileName: React.PropTypes.string.isRequired,
    audit: React.PropTypes.shape(RoadmapEntity.auditShape),
    loading: React.PropTypes.bool,
    updating: React.PropTypes.bool,
  };

  constructor(roadmap) {
    if (roadmap) {
      Object.assign(this, roadmap);
    }
  }

  static validate = (roadmap) => {
    const errors = {};
    if (!roadmap) {
      return errors;
    }

    if (roadmap.file && roadmap.file.size > 35000000) {
      errors.file = 'Taille limite de la feuille de route : 35Mo';
    }

    return errors;
  };

  // eslint-disable-next-line class-methods-use-this
  get title() {
    return 'Feuille de route';
  }

  get isUpdated() {
    return this.audit && this.audit.updateDateTime
      && moment().diff(this.audit.updateDateTime, 'weeks') === 0;
  }

  get attachmentUrl() {
    return this.fileName && `/api/roadmap/${encodeURIComponent(this.fileName)}`;
  }

}



// WEBPACK FOOTER //
// ./shared/src/entity/RoadmapEntity.js